import { render } from "./RainbowChart.vue?vue&type=template&id=7890d458"
import script from "./RainbowChart.vue?vue&type=script&lang=js"
export * from "./RainbowChart.vue?vue&type=script&lang=js"

import "./RainbowChart.vue?vue&type=style&index=0&id=7890d458&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__